import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a28b4ede"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "q-pa-sm bg-grey-3 rounded-borders" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_message = _resolveComponent("message")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("span", null, [
    (_ctx.isGranted('VIEW_USER_INVITATION_LINK'))
      ? (_openBlock(), _createBlock(_component_q_btn, {
          key: 0,
          icon: "fa fa-link",
          label: "Copy Invite Link",
          color: "red",
          loading: _ctx.isLoading,
          onClick: _ctx.fetchLink
        }, null, 8, ["loading", "onClick"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Modal, {
      ref: "modal",
      title: "Invitation Link",
      size: "xs"
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_q_btn, {
          color: "primary",
          label: "Copy",
          onClick: _ctx.copyLink
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_message, { class: "text-center q-my-sm" }, {
          default: _withCtx(() => [
            _createTextVNode(" Click the link below to copy it to your clipboard: ")
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("a", {
            href: "#",
            class: "invitation-link text-primary",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.copyLink && _ctx.copyLink(...args)), ["prevent"]))
          }, _toDisplayString(_ctx.invitationUrl), 1)
        ])
      ]),
      _: 1
    }, 512)
  ]))
}